// http://worldtimeapi.org/api/timezone/
import axios from "axios";
import {useState, useEffect} from 'react';
import Select from 'react-select';

export default function WorldClock(){

    const [listOfTimeZones, setListOfTimeZones] = useState(()=>[]);
    const [selectedTimeZone, setSelectedTimeZone] = useState(()=>'');
    const [dateTime, setDateTime] = useState(()=>''); //new Date().toLocaleString()

    const [listClocks, setListClocks] = useState(()=>[]);

    // used for DROPDOWN using old [select and option] which was not searchable
    // const hTimeZone = (event) => { setSelectedTimeZone(event.target.value); }

    const hTimeZone = (obj) => { setSelectedTimeZone(obj); }

    const fetchListOfTimeZones = async() => {
        const url = 'https://worldtimeapi.org/api/timezone/';
        axios.get(url)
        .then(response => {
            // console.log('response: ', response.data);
            setListOfTimeZones(response.data);
            setSelectedTimeZone({value:response.data[0], label: response.data[0]})
        })
        .catch(err => {
            console.log('err: ', err);
        });
    }
    useEffect(()=>{fetchListOfTimeZones()}, []);

    // const fetchCurrentTime = async() => {
        // const url = `http://worldtimeapi.org/api/timezone/${selectedTimeZone}`;
        // console.log('url: ', url);
        // axios.get(url)
        // .then(response => {
        //     let time = response.data.datetime.split('.')[0];
        //     console.log('response time:', time);
        //     console.log('Current Date: ', new Date().toLocaleString());
        //     console.log('receivedDate: ', new Date(time.toString()).toLocaleString());
        //     setDateTime(response.data.datetime.toLocaleString());
        // })
        // .catch(err => {
        //     console.log('err: ', err);
        // })

    //     console.log('selectedTimeZone: ', selectedTimeZone);
    //     const url = `http://worldtimeapi.org/api/timezone/${selectedTimeZone.value}`;
    //     try {
    //         const response = await axios.get(url);
    //         const time = response.data.datetime.split('.')[0];
    //         // console.log('response.data: ', response.data);
    //         console.log('time: ', time);
    //         console.log('new Date(: ', new Date());
    //         const dateObj = new Date(time);
    //         setDateTime(dateObj);
    //     } catch (error) {
    //         console.log('Error:', error);
    //     }
    // }

    // // Function to increment time by one second
    // function incrementTime() {
    //     if (dateTime!=''){
    //         let temp = dateTime;
    //         console.log("setting time to ", dateTime.toString());
    //         temp.setSeconds(temp.getSeconds() + 1);
    //         console.log("done setting time",temp.toString());
    //         setDateTime(temp);
    //     }
    // }

    useEffect(()=>{
        console.log("inside WorldClock");
        // Call the incrementTime function every second
        // const interval = setInterval(fetchCurrentTime, 1000);
        const interval = setInterval(()=>{setDateTime(getCurrentTime(selectedTimeZone.value))}, 1000);
        return () => {
            clearInterval(interval);
        };
    },);

    function getCurrentTime(timezone) {
        const options = { timeZone: timezone };
        const currentTime = new Date().toLocaleString('en-US', options);
        return currentTime;
    }


    // Check for duplicate label
    // const isDuplicate = (checkInList, checkElement, checkItem) => {
    //     return checkInList.some(
    //         (objItem) => {

    //             console.log('objItem[checkElement]: ', objItem[checkElement]);
    //             console.log('checkItem: ', checkItem);
    //             console.log('checkElement: ', checkElement);
    //             return objItem[checkElement] === checkItem;
    //         }
    //     );
    // }

    const addClock = () => {
        console.log('selectedTimeZone: ', selectedTimeZone);
        console.log('dateTime: ', dateTime);
        console.log('listClocks: ', listClocks);
        // console.log('[...listClocks, {...selectedTimeZone, dateTime}]: ', [...listClocks, {...selectedTimeZone, dateTime}]);

        // Check for duplicate label or value
        // prev.some(
        //     (item) => item.label === newItem.label
        // )
        setListClocks(prev => {
            if ((prev.length>0)&&(prev.some((item) => item.label === selectedTimeZone.label))) {
                console.log('Duplicate found!', 'updating only time');
                // return prev
                return prev.map((item) => {
                    if (item.label === selectedTimeZone.label) {
                    return { ...item, dateTime };
                    }
                    return item;
                });
            }else{
                return [...prev, {...selectedTimeZone, dateTime}];
            }
        });
    }

    const removeClock = (index) => {
        setListClocks((prevClocks) => {
            const updatedClocks = [...prevClocks];
            updatedClocks.splice(index, 1);
            return updatedClocks;
        });
    };



    useEffect(() => {
        const timer = setInterval(() => {
            setListClocks((prevClocks) => {
                return prevClocks.map((clock) => {
                const updatedDateTime = getCurrentTime(clock.value);
                return { ...clock, dateTime: updatedDateTime };
                });
            });
        }, 1000);

        return () => {
            clearInterval(timer);
        };

    }, [listClocks]);    

    return(
        <>
            <div style={selectStyles.singleLineContainer}>
                <label className="border" style={selectStyles.label}> Select TimeZone </label>
                <Select
                    options={listOfTimeZones.map((item) => ({
                        label: item,
                        value: item,
                    }))}
                    loadingMessage={"loding"}
                    value={selectedTimeZone}
                    onChange={hTimeZone}
                    isSearchable={true}
                    styles={selectStyles}
                />
            <p className="border" style={selectStyles.time} >{dateTime.toLocaleString()}</p>
            </div>
            {/* 
            <select onChange={hTimeZone} >
                {
                    listOfTimeZones.map((item,index) => <option key={index} value={item}>{item}</option>)
                }
            </select> */}
            {/* <button className="border" onClick={()=>{ console.log("selectedTimeZone:",selectedTimeZone.value); return setDateTime(getCurrentTime(selectedTimeZone.value)); } }>Fetch Current Time</button> */}

            <button className="border" onClick={()=>{return addClock()}}>Add Clock </button>
            {
                (listClocks.length>0)&&
                <div className="border">
                    {
                        listClocks.map((item, index) => {
                            return (
                                <div key={index}>
                                    {item.label} {item.dateTime}
                                    <button className="btnBorder" onClick={()=> removeClock(index)}>Remove</button>
                                </div>
                            )
                        })
                    }
                </div>
            }
        </>
    );
}
const selectStyles = {
    singleLineContainer: { 
        display: 'flex', 
        alignItems: 'center',
        justifyContent: 'center',
    },
    control: (provided, state) => ({
        ...provided,
        minWidth: '100%',
        padding: '0px 0px',
        margin: '0px 0px 0px 0px',
        border: state.isFocused ? '3px solid blue' : '3px solid black',
        borderRadius: '10px',
        background: state.isDisabled
        ? 'linear-gradient(135deg, #ccc, #eee)'
        : 'linear-gradient(135deg, #14ffe9, #ffeb3b, #ff00e0)',
        marginRight: '10px',
    }),
    label: {
        // display: 'inline-block',
        marginRight: '10px',
        marginLeft: '0px',
        width: '140px',
    },
    time: {
        margin: '0 0 0 10px',
        width: '140px',
    }

};
